<template>
  <body @keyup="keyup" v-on:click="closeOverlays"
    :data-kt-app-layout="'light-header'/*settings.appLayout*/" data-kt-app-header-fixed="true"
    data-kt-app-toolbar-enabled="true" :data-kt-app-sidebar-fixed="settings.appLayout.indexOf('-sidebar') > 0"
    :data-kt-app-sidebar-push-header="settings.appLayout.indexOf('-sidebar') > 0"
    :data-kt-app-sidebar-minimize="settings.sidebarMinimize ? 'on' : 'off'"
    :class="{'app-mobile': device == 'MOBILE', 'app-ipad': device == 'IPAD'}"
    >
    <div class="d-flex flex-column flex-root app-root">
      <div v-if="!ready" style="text-align:center;margin-top:calc(50vh - 0.5em)" v-text="readyTxt" />
      <Login v-else-if="!user.kind" ref="content" />
      <div v-else class="app-page flex-column flex-column-fluid">
        <form onsubmit="return false" autocomplete="off">
          <div style="height:0;overflow:hidden"><input class="fake4autocomplete" /><input class="fake4autocomplete" type="password" /></div>

          <Header v-if="device == 'WEB'"></Header>

          <div class="app-wrapper flex-row flex-column-fluid">
            <router-view ref="content" />
          </div>
        </form>
      </div>
      <ContextMenu v-if="contextmenu.menu" :menu="contextmenu.menu" :xy="[contextmenu.evt.x, contextmenu.evt.y]" />
      <Progress v-if="progress.keep || progress.progress < 100" :value="progress.keep || progress.progress"
        :text="progress.title || 'Loading...'" />
    </div>
  </body>
</template>

<script>
import Header from "@/components/layout/Header.vue";
import Login from "./views/Login.vue";
import ContextMenu from '@/components/ContextMenu.vue';
import Progress from '@/components/Progress.vue';
import { inihub } from './config';
import { files2data } from './utils';
let lastEnterTime = 0;

export default {
  name: "app",
  components: { Header, Login, ContextMenu, Progress },
  computed: {
    settings() { return this.$store.state.settings },
    progress() { return this.$store.state.progress },
    contextmenu() { return this.$store.state.contextmenu },
    user() { return this.$store.state.user },
    device() { return this.$getDevice(); },
  },
  watch: {
    '$route.path'(path) {
      if (path.startsWith('/adm/') && this.user.availAdm != 'Y') this.$router.replace('/');
      this.$store.commit('contextmenu');
    },
    'settings.lang': '$setCodes',
  },
  async created() {
    if (window.location.search.indexOf('linkKey=') > -1) {
      const linkKey = window.location.search.split('linkKey=')[1].split('&')[0];

      var result;
      var authCode = '';
      let times = 0;
      while (times++ < 100) {
        result = await this.$api('nonauth/main/env/linkSigner', { linkKey, authCode });
        if (result.code < 0) {
          if (result.code == -1 || result.code == -2) {
            if (result.code == -2) {
              await this.$alert(result.msg, { title: 'MeDP' });
            }

            setTimeout(() => document.querySelector('#auth_code_input').focus(), 100);
            await this.$alert(`<input maxlength=100 id=auth_code_input type="password" class="form-control" placeholder="${this.$t('인증코드')}">`, { title: this.$t('인증코드') });
            authCode = window.auth_code_input.value;
            continue;
          }
          break;
        } else {
          const env = result.data;
          const { partiNm: userNm, partiEmail: email } = env.partiList[env.myPartiNo] || {};
          await this.$store.commit('user', { userNm, email, kind: 'main', custId: env.custId, env, linkKey });
          await this.$store.commit('enteredAuthCode', authCode);
          await this.$router.replace('/env');

          if (result.code == 2) {
            await this.$alert(result.msg, { title: 'MeDP' });
          } else {
            // 인증서 작성 사용자일 경우
            const myParti = env.partiList.find(r => r.partiNo == env.myPartiNo);
            if (myParti.confType == 'C_CERTI' || myParti.confType == 'P_CERTI') {
              while (times++ < 100) {
                setTimeout(() => {
                  var idnInput = document.querySelector('#idn_input');
                  idnInput.focus();
                  idnInput.value = this.idn;
                }, 200);

                if (myParti.confType == 'C_CERTI') { // 법인인증서
                  await this.$alert(`<input maxlength=100 id=idn_input type="text" class="form-control" placeholder="${this.$t('사업자등록번호')}">`, { title: this.$t('사업자등록번호') });
                  this.idn = window.idn_input.value;
                  if (this.idn && this.idn != '') {
                    if (this.idn.test('registno')) {
                      break;
                    } else {
                      await this.$alert(this.$t('$ 형식을 확인하세요.', [this.$t('사업자등록번호')]));
                    }
                  }
                } else { // 개인인증서
                  await this.$alert(`<input maxlength=100 id=idn_input type="text" class="form-control" placeholder="${this.$t('이름')}">`, { title: this.$t('이름') });
                  this.idn = window.idn_input.value;
                  if (this.idn && this.idn != '') {
                    break;
                  }
                }
              }
            }
          }

          break;
        }
      }

      if (result.code < 0) {
        await this.$alert(result.msg, { title: 'MeDP' });
        this.$router.replace('/');
      }
    }
    else if (this.user.linkKey || this.user.userId != window.sessionStorage.userId) await this.$store.commit('user');
    window.$vm = this;
    window.addEventListener('resize', () => this.$store.commit('contextmenu'));
    document.body.parentNode.dataset.theme = 'light';//this.$store.state.settings.darkmode ? 'dark' : 'light';
    window.ktdp_api = async (url, data, opt = {}) => {
      if (url == 'drawSign') { // 'drawSign', confType
        const signAuthYn = (data + '').indexOf('_CERTI') > 0 ? 'Y' : 'N', encrypt = true, masking = true;
        const { env, signerScope, linkKey } = opt.inihub ? {} : this.$refs.content;
        const { envNo, envSeq, myPartiNo: partiNo, myUi: ui } = env || {};
        let signFileId, signedAuthToken, res = {};
        if (!opt.inihub) {
          const form = await signerScope.$refs.printer.getForms();
          form.append('encrypt', encrypt);
          form.append('masking', masking);
          form.append('signAuthYn', signAuthYn);
          form.append('envNo', envNo);
          form.append('envSeq', envSeq);
          form.append('partiNo', partiNo);
          form.append('ui', ui);
          form.append('docFileId', env.envDocList.map(d => d.docFileId).join(','));
          if (env.signFileId) form.append('preSignFileId', env.signFileId);
          if (linkKey) form.append('linkKey', linkKey);
          res = (await this.$api((linkKey ? 'nonauth/' : '') + 'main/env/sign/prepare', form)).data;
          signFileId = res.signFileId;
        }
        let myType = '';
        if (signAuthYn == 'Y') {
          try {
            // const { clientId:inihubClientIds, baseUrl, companyOids } = Object.assign(inihub, opt.inihub);
            const { clientId: inihubClientIds, baseUrl } = Object.assign(inihub, opt.inihub);
            const type = opt.type || 'pblc_cwui';// data.indexOf('FIN_CERTI') > -1 ? 'kftc' : 'pblc_cwui';//kftc:금융 pblc_cwui:공동
            let clientId = inihubClientIds[0];
            myType = type == 'kftc' ? '_FIN' : '_JOINT';
            if (opt.inihub) {
              await this.$loadScript('/libs/inihub.js');
              console.log('IHUB_C.init', { type, baseUrl: baseUrl || location.origin, clientId });
              await window.IHUB_C.init({ type, baseUrl: baseUrl || location.origin, clientId });
            }
            const authParam = opt.authParam || { signType: 'pdf', polName: ['PDF_HD_SIGN', 'PDF_SIGN'], type: 'CONTRACT', iniCache: true };
            if (data == 'C_CERTI') {
              // if(type=='pblc_cwui') authParam.policy = {CertOIDs:companyOids.join('|')};
              // else authParam.fin_param = {view:{oid:companyOids}};
              clientId = inihubClientIds[1];
              myType = 'C' + myType;
            }
            else myType = 'P' + myType;
            const contents = { HD: signFileId, MD: [res.hash] };
            console.log('IHUB_C.sign', { type, clientId, authParam, contents });
            res = await window.IHUB_C.sign({ type, clientId, authParam, contents });
            if (opt.inihub) return console.log(res);
            if (res.resCode != 1200) return this.$alert(res.errorMessage, { title: 'IHUB_C.sign' });
            signedAuthToken = res.authToken;
          } catch (e) {
            this.$alert(this.$t('전자서명에 실패했습니다.'), { title: 'IHUB_C.sign' });
            throw e;
          }
        }
        res = await this.$api((linkKey ? 'nonauth/' : '') + 'main/env/sign/write', { certiType: myType, linkKey, idn: this.idn, envNo, envSeq, partiNo, encrypt, masking, signFileId, signAuthYn, signedAuthToken });
        if (!res.success) {
          this.$alert(res.msg);
          throw res.msg;
        }
        signFileId = res.data.signFileId;
        if (ui == env.partiList.length - 1) {
          const { success, msg } = await this.$api((linkKey ? 'nonauth/' : '') + 'main/env/sign/finalTsa', { linkKey, envNo, envSeq, partiNo, encrypt, masking, signFileId });
          if (!success) {
            this.$alert(msg);
            throw msg;
          }
        }
      }
      // else if (url == 'e-sign') {// 'e-sign', this, ctrl
      //   const signImageUrl = '/assets/esign.png';
      //   const { env, signerScope } = this.$refs.content;
      //   if (!signerScope) return data.popup = opt;
      //   const docId = env.envDocList.map(d => d.docId).join('_');
      //   const form = await signerScope.getPdf(`${env.envNo}_${env.envSeq}_${docId}.pdf`, 'pdfFile');
      //   const testMode = env.envNo == '46d4ab40-d9cf-11ed-9e39-02420a00000d';
      //   form.append('envNo', env.envNo);
      //   form.append('envSeq', env.envSeq);
      //   form.append('docId', docId);
      //   let page = 1;
      //   for (let i = 0; i < opt.di - 1; i++) page += signerScope.docs[i].pages.length;
      //   page += opt.pi;
      //   if (testMode) form.append('signElementList', JSON.stringify(signerScope.inputs.map(i => ({ imageFileName: 'esign.png', page, posX: Math.round(i.xywh[0] - i.xywh[2] / 2), posY: Math.round(i.xywh[1] - i.xywh[3] / 2), width: i.xywh[2], height: i.xywh[3], }))));
      //   else form.append('signElementList', JSON.stringify([{ imageFileName: 'esign.png', page, posX: Math.round(opt.xywh[0] - opt.xywh[2] / 2), posY: Math.round(opt.xywh[1] - opt.xywh[3] / 2), width: opt.xywh[2], height: opt.xywh[3], }]));
      //   if (testMode) form.append('signImage', await (await fetch(signImageUrl)).blob(), 'esign.png');
      //   form.append('signImage', await (await fetch(signImageUrl)).blob(), 'esign.png');
      //   for (const k of form.keys()) console.log(k, form.get(k));
      //   const { data: { hash } } = await this.$api('main/env/prepareSignature', form);
      //   try {
      //     const { baseUrl, clientId } = inihub;
      //     await this.$loadScript('/libs/inihub.js');
      //     // (env.envRoleList.find(r=>r.partiNo==env.myPartiNo)||{}).confType; 2:공동(pblc_cwui), 3:금융(inihub)
      //     const type = 'pblc_cwui';// inihub pblc_cwui kftc 
      //     inihub.init = await window.IHUB_C.init({ type, baseUrl, clientId });
      //     const res = await window.IHUB_C.sign({ type, clientId, contents: { MD: [hash] }, authParam: { signType: "pdf" } });
      //     if (res.resCode != 1200) return this.$alert(res.errorMessage, { title: 'IHUB_C.sign' });
      //     this.$alert((await this.$api('main/env/sign', { envNo: form.get('envNo'), envSeq: form.get('envSeq'), docId: form.get('docId'), signedAuthToken: res.authToken })).msg);
      //     opt.value = signImageUrl;//인증이미지
      //     data.setCurrents();
      //   } catch (e) {
      //     if (!inihub.init) this.$alert(this.$t('전자서명을 준비할 수 없습니다.'), { title: 'IHUB_C.init' });
      //     else this.$alert(this.$t('전자서명에 실패했습니다.'), { title: 'IHUB_C.sign' });
      //   }
      //   return;
      // }

      const { linkKey } = this.$refs.content;

      if (url.indexOf('file/') == 0 && data) {
        const { env } = this.$refs.content;
        data = files2data([data]);
        data.append('envNo', env.envNo);
        data.append('envSeq', env.envSeq);
        data.append('attachType', 'INTERNAL');
        if (env.myPartiNo != undefined) data.append('partiNo', env.myPartiNo);
        const { list, msg } = await this.$api((linkKey ? 'nonauth/' : '') + 'main/env/insertEnvAttachFileList', data);
        return { url: `${location.origin}${this.$url(list.pop().url, true)}`, rstxt: msg };
      }
      else if (url.indexOf('my/') == 0) {// 'e-sign', null, ctrl
        if (data) {
          return { url: data };
          // data = files2data([{ name: url.slice(3) + '.png', blob: await (await fetch(data)).blob() }])
        }
        else {
          const api = url == 'my/stamp' ? 'selectStampList' : 'selectSignList';
          const list = (await this.$api((linkKey ? 'nonauth/' : '') + 'main/env/' + api, {})).list.filter(s => opt.company ? s.stampOwnerType == 1 : s.stampOwnerType != 1).reverse();
          return {
            emptyMsg: this.$t(opt.company ? '할당된 법인 도장/서명이 없습니다.' : '등록된 정보가 없습니다.<br>내 정보 변경에서 추가 가능합니다.'),
            imgs: list.map(s => this.$url(s.stampFileUrl)),
            dateStamps: list.filter(s => s.stampType == '0').map(s => this.$url(s.stampFileUrl))
          };
          // if (url == 'my/stamp') return { "imgs": ["/assets/stamp.png", "/assets/stamp.png", "/assets/stamp.png", "/assets/stamp.png", "/assets/stamp.png", "/assets/stamp.png"] };
          // else return { "imgs": ["/assets/sign.png", "/assets/sign.png", "/assets/sign.png", "/assets/sign.png", "/assets/sign.png", "/assets/sign.png"] };
        }
      }
      else if (url.indexOf('pass/') == 0) {
        if (data) {
          const { user: { userId, userNm: partiNm, email: partiEmail }, ctrls } = data;
          const { env: { envNo, envSeq, myPartiNo: partiNo }, signerScope: { inputs } } = this.$refs.content;
          const { success, msg } = await this.$api('main/env/transferEnvCtrl', {
            envNo, envSeq, partiNo,
            myJsonCtrls: JSON.stringify(inputs.filter(i => !ctrls.includes(i))), txJsonCtrls: JSON.stringify(ctrls),
            userId, partiNm, partiEmail,
          });
          if (!success) {
            this.$alert(msg);
            throw msg;
          }
          return { rstxt: msg };
        }
        else {
          const { success, msg, list } = await this.$api('main/env/selectTxUserList', {}, opt);
          if (!success) {
            this.$alert(msg);
            throw msg;
          }
          return { users: list, rstxt: msg };
        }
      }
      else if (url == 'replaceEnvCtrls') {
        const { env: { envNo, envSeq, myPartiNo: partiNo, myUi: ui }, linkKey } = this.$refs.content;
        const { msg: rstxt } = await this.$api((linkKey ? 'nonauth/' : '') + 'main/env/replaceEnvCtrls', { envNo, envSeq, partiNo, ui, jsonCtrls: data.newInputs, statusCd: data.statusCd, linkKey });
        return { rstxt };
      }
      // return await this.$api('/test-api/' + url, data, opt);
      return console.log(url, data, opt);
    };
    if (!this.settings.lang) {
      await this.$store.commit('settings', { lang: navigator.language.split('-')[0] });
    }

    await this.$setCodes(this.settings.lang);

    this.$setFileTypes();

    this.ready = true;
  },
  data: () => ({
    readyTxt: 'Loading...', 
    ready: false, 
    idn: '',
  }),
  methods: {
    closeOverlays(event) {
      // 프로필 Close
      this.$store.commit('toggleProfile', false);
      
      // 사이드바 Close
      this.$store.commit('toggleSidebar', false);

      // 메뉴 Close
      this.$store.commit('contextmenu');

      // Drawer Close
      if (this.$refs && this.$refs.content) {
        const contentRefs = this.$refs.content.$refs;
        if(contentRefs) {
          for (const key in contentRefs) {
            if (/Drawer$/.test(key) && contentRefs[key]) contentRefs[key].closeDrawer();
          }
        }
        
        const editorRefs = this.$refs.content.editorScope;
        if(editorRefs) {
          editorRefs.initialCtrl();
        }
      }

      // 사이드메뉴 Close
      this.closeSidebar(event);
    },
    /** 사이드메뉴 Close */
    closeSidebar(event) {
      let targetEl = event.target.closest('.exclude_close_overlays');
      if (!targetEl) { // 닫기 상황 제외
        const sidemenu = document.querySelectorAll('.sidemenu');
        sidemenu.forEach(menu => { menu.classList.remove('show'); });
        const sidemenuBackdrop = document.querySelectorAll('.sidemenu-backdrop');
        sidemenuBackdrop.forEach(backdrop => { backdrop.classList.remove('show'); });
      }
    },
    keyup(e) {
      switch (e.key) {
        case 'Enter': {
          const el = e.target;
          if (['TEXTAREA'].includes(el.tagName) || el.classList.contains('b-form-tags-input')) return;
          const okBtns = document.querySelectorAll('.modal-footer .btn-primary');
          const now = Date.now();// 3초 이내면 무시
          if (okBtns.length && lastEnterTime + 3000 < now) {
            lastEnterTime = now;
            okBtns[okBtns.length - 1].click();
          }
          break;
        }
      }
    }
  },
}
</script>
